import { Controller } from "@hotwired/stimulus"

// Ustawienia — hub integracji księgowej: pokazuje pola formularza
// właściwe dla wybranego dostawcy (Fakturownia/iFirma/wFirma) i ukrywa
// pozostałe. Analogiczne do buyer_kind_controller.js.
export default class extends Controller {
  static targets = [ "fakturowniaFields", "ifirmaFields", "wfirmaFields" ]

  connect() {
    this.toggle()
  }

  toggle() {
    const checked = this.element.querySelector('input[name="accounting_credential[provider]"]:checked')
    const provider = checked ? checked.value : null

    this.fakturowniaFieldsTarget.classList.toggle("hidden", provider !== "fakturownia")
    this.ifirmaFieldsTarget.classList.toggle("hidden", provider !== "ifirma")
    this.wfirmaFieldsTarget.classList.toggle("hidden", provider !== "wfirma")
  }
}
